module.exports = __webpack_public_path__ + "img/wx_applet_qrcode.e30625d9.jpg";